import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=9f7a6356&scoped=true&"
import script from "./UploadDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=9f7a6356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7a6356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f7a6356')) {
      api.createRecord('9f7a6356', component.options)
    } else {
      api.reload('9f7a6356', component.options)
    }
    module.hot.accept("./UploadDocuments.vue?vue&type=template&id=9f7a6356&scoped=true&", function () {
      api.rerender('9f7a6356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadFile/UploadDocuments.vue"
export default component.exports